import { Location } from '@remix-run/router';
import { FC, createContext, useContext, useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation } from 'react-router';

type HistoryContextType = { history: Location[]; lastLocation?: Location };
const HistoryContext = createContext<HistoryContextType>({ history: [] });
export const useHistory = () => useContext(HistoryContext);

export const HistoryProvider: FC = () => {
  const location = useLocation();
  const [history, setHistory] = useState<Location[]>([]);

  const lastLocation = useMemo(
    () => [...history].reverse().find(({ pathname }) => pathname !== location.pathname),
    [history, location.pathname]
  );

  useEffect(() => {
    if (lastLocation?.pathname !== location.pathname) {
      setHistory(p => [...p, location]);
    }
  }, [lastLocation, location, setHistory]);

  return (
    <HistoryContext.Provider value={{ history, lastLocation }}>
      <Outlet />
    </HistoryContext.Provider>
  );
};
